import { Action } from '../../utils/action.model';
import {menuInterface, datosPersonalesInterface} from '../../../Model/Administracion/menu.Interface';

export enum MenuActionTypes {
    GetMenus = '[Menus] Array con los menus del sistema segun el usuario logueado',
    PostMenus = '[Menus] Se dispara cuando se hace una accion post and put',
    PostDataPersonal = '[Menus] guardar nombres'
}

export class PostMenus implements Action {
    readonly type = MenuActionTypes.PostMenus;
    constructor(public payload: any) { }
}


export class GetMenus implements Action {
    readonly type = MenuActionTypes.GetMenus;
    constructor(public payload: menuInterface[]) { };
}



export type Menus = GetMenus | PostMenus 